import type { ComponentProps } from 'react';

type RtlPlusLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string];
};

const RtlPlusLogo = ({ colors, ...props }: RtlPlusLogoProps) => {
  return (
    <svg viewBox="0 0 82 12" focusable="false" role="img" {...props}>
      <title>RTL+</title>
      <path fill={colors?.[0] ?? '#020203'} d="M0 0h21.338v12H0z" />
      <path
        fill={colors?.[0] === '#fff' ? '#020203' : '#fff'}
        d="M6.061 2.758h5.686c1.731 0 2.695.778 2.695 2.084 0 1.12-.723 1.871-1.954 2.047l2.788 2.353h-2.139l-2.621-2.27H7.544v2.269H6.062V2.758h-.001Zm5.492 3c.917 0 1.361-.296 1.361-.898 0-.603-.444-.89-1.361-.89H7.544v1.787h4.009v.001Z"
      />

      <path fill={colors?.[1] ?? '#020203'} d="M23.47 0h21.338v12H23.47z" />
      <path
        fill={colors?.[1] === '#fff' ? '#020203' : '#fff'}
        d="M33.397 4.036h-3.75V2.758h8.983v1.278h-3.75v5.206h-1.483V4.036Z"
      />

      <path fill={colors?.[2] ?? '#020203'} d="M46.939 0h21.338v12H46.939z" />
      <path fill={colors?.[2] === '#fff' ? '#020203' : '#fff'} d="M53.57 2.758h1.481v5.206h6.594v1.278H53.57V2.758Z" />

      <path
        fill={colors ? '#fff' : '#020203'}
        d="M81.081 5.233h-3.496V2.594h-1.546v2.639h-3.493v1.548h3.493v2.621h1.546V6.781h3.496V5.233Z"
      />
    </svg>
  );
};

export default RtlPlusLogo;
